<template>
    <div class="t-box">
        <h1>邀请好友活动规则</h1>
        <p>1.邀请对象必须是未注册过小睡眠App的新用户</p>
        <p>2.本活动仅限中国大陆手机号参与</p>
        <p>3.受到邀请的新用户在网页内领取权益后，使用同一手机号登录小睡眠APP激活，即视为邀请成功</p>
        <p>4.每次邀请成功新用户和邀请人各自3天权益奖励，每个用户通过邀请新用户可获得的权益奖励上限为15天</p>
        <p>5.如发现恶意批量注册等违规行为，小睡眠将封停处理违规账号并撤销相关奖励</p>
        <p>6.如有其他疑问，欢迎从小睡眠APP中“我的-帮助与反馈-联系客服”，与我们联系</p>
    </div>
</template>

<script>
export default {
    data(){
        return {

        }
    },
    created(){

    },
    mounted(){
        document.title = '邀请规则'
    },
    methods:{

    },
}
</script>

<style lang='scss' scoped>

</style>